// extracted by mini-css-extract-plugin
export var sliderRange = "_cd-2";
export var sliderRoot = "_cd-0";
export var sliderThumb = "_cd-3";
export var sliderTrack = "_cd-1";